export const Tabs = ({
  LABELS: {
    key: 'LABELS',
    title: 'Labels'
  },
  ANNOTATIONS: {
    key: 'ANNOTATIONS',
    title: 'Annotations'
  }
} as const);
export const TabsM3 = ({
  CLASSES: {
    key: 'CLASSES',
    title: 'Classes'
  },
  ANNOTATIONS: {
    key: 'ANNOTATIONS',
    title: 'Annotations'
  }
} as const);
export const DRAWER_MODE = ({
  SIDE_DRAWER: 'side-drawer',
  STACKED_DRAWER: 'stacked-drawer'
} as const);
export type DrawerModeT = (typeof DRAWER_MODE)[keyof typeof DRAWER_MODE];
export const SHORT_TOAST_DURATION = 2000;
export const LONG_TOAST_DURATION = 3000;
export const SIDE_PANEL_ACTIONS = ({
  SELECT_ANNOTATION: 'SELECT_ANNOTATION',
  SELECT_ANNOTATION_LABEL: 'SELECT_ANNOTATION_LABEL',
  EDIT_ANNOTATION_END: 'EDIT_ANNOTATION_END',
  UPDATE_ANNOTATION: 'UPDATE_ANNOTATION',
  UPDATE_ANNOTATION_LABEL: 'UPDATE_ANNOTATION_LABEL',
  UPDATE_ANNOTATION_QUESTIONNAIRE: 'UPDATE_ANNOTATION_QUESTIONNAIRE',
  EDIT_ANNOTATION_START: 'EDIT_ANNOTATION_START',
  LOCK_ANNOTATIONS: 'LOCK_ANNOTATIONS',
  SHOW_HIDE_ANNOTATIONS: 'SHOW_HIDE_ANNOTATIONS',
  DELETE_ANNOTATION: 'DELETE_ANNOTATION',
  DELETE_ANNOTATIONS: 'DELETE_ANNOTATIONS',
  SET_FOCUSED_ANNOTATION: 'SET_FOCUSED_ANNOTATION',
  DELETE_ANNOTATION_FRAME_SPAN: 'DELETE_ANNOTATION_FRAME_SPAN',
  SELECT_FILTER: 'SELECT_FILTER',
  ADD_INSTANCE_LABEL: 'ADD_INSTANCE_LABEL',
  IMPORT_ML_ANNOTATIONS: 'IMPORT_ML_ANNOTATIONS',
  COPY_ANNOTATION_ID: 'COPY_ANNOTATION_ID',
  UPDATE_ANNOTATION_PROPAGATION_METHOD: 'UPDATE_ANNOTATION_PROPAGATION_METHOD',
  APPLY_FRAME_CLASSIFICATION_SPAN: 'APPLY_FRAME_CLASSIFICATION_SPAN'
} as const);
export const LABEL_COLOR_MODIFICATION_ERROR = 'You cannot change the color for labels with "_" in the name. Please contact support.';
export const TASK_QUESTIONNAIRE_ID = 'task-questionnaire';
export const TASK_QUESTIONNAIRE_TITLE = 'Task Qs';